/*
*  ajaxテスト専用メソッド

   $.testingAjax({
     type     : "GET",
     url      : "/sample",
     data     : {},
     dataType : "json"
     response : {
         done         : { neko:"tanuki" },
         responseTime : "2000",
     }
   })

*/
const $ = require('jquery')

module.exports = (function () {
  $.extend({
    testingAjax: function (reqData) {
      let response = {}
      const testingXhr = {}
      let responseTime = 1000

      if (reqData.response) {
        response = reqData.response
      }

      if (response.responseTime) {
        responseTime = response.responseTime
      }

      testingXhr.done = function (callback) {
        if (response.done) {
          setTimeout(function () {
            callback(response.done)
          }, responseTime)
        };
        return testingXhr
      }

      testingXhr.fail = function (callback) {
        if (response.fail) {
          setTimeout(function () {
            callback(
              { status: 400, responseJSON: response.fail }, // jqXHR
              'error', // textStatus
              'error' // errorThrown
            )
          }, responseTime)
        };
        return testingXhr
      }

      testingXhr.always = function (callback) {
        let responseAlways = {}

        if (response.done) {
          responseAlways = response.done
        } else if (response.fail) {
          responseAlways = response.fail
        }

        setTimeout(function () {
          callback(responseAlways)
        }, responseTime)

        return testingXhr
      }

      return testingXhr
    }
  })
})()
